// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const RenameIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 12,
  fill: "none",
  viewBox: "0 0 14 12",
  "aria-hidden": "true",
  "data-icon": "Rename/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M7.913 3H.75v5.903h6.964"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.705 3h1.83v5.903h-1.631"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.309 11.001h2.913-1.47V.75h1.47H8.31"
}));
export default RenameIcon;
